import { FormField } from './FormField';

export const NumberField = ({ name, title, placeholder, hidden }) => {
  return (
    <FormField name={name} title={title} type="number" placeholder={placeholder} hidden={hidden} />
  );
};